import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { toast } from '@page/ui';

interface ShowAsyncNotificationOptionss {
  id?: string;
  withoutIcon?: boolean;
  withCloseButton?: boolean;
  autoClose?: boolean | number;
  className?: string;
}

export const showAsyncNotification = (
  title: React.ReactNode,
  message: React.ReactNode,
  options?: ShowAsyncNotificationOptionss,
) => {
  const notificationId = options?.id || uuidv4();

  toast.loading(title, {
    id: notificationId,
    description: message,
    duration: !options?.autoClose ? undefined : (options?.autoClose as number) ?? 5000,
    ...(options?.withoutIcon ? { icon: null } : {}),
  });

  const update = (title: React.ReactNode, message: React.ReactNode, opts?: ShowAsyncNotificationOptionss) => {
    toast.loading(title, {
      id: notificationId,
      description: message,
      duration: !opts?.autoClose ? undefined : (opts?.autoClose as number) ?? 5000,
      ...(opts?.withoutIcon ? { icon: null } : {}),
    });
  };

  const onSuccess = (title: React.ReactNode, message: React.ReactNode, opts?: ShowAsyncNotificationOptionss) => {
    toast.success(title, {
      id: notificationId,
      description: message,
      duration: opts?.autoClose === false ? undefined : (opts?.autoClose as number) ?? 5000,
      ...(opts?.withoutIcon ? { icon: null } : {}),
    });
  };

  const onError = (title: React.ReactNode, message: React.ReactNode, opts?: ShowAsyncNotificationOptionss) => {
    toast.error(title, {
      id: notificationId,
      description: message,
      duration: opts?.autoClose === false ? undefined : (opts?.autoClose as number) ?? 5000,
      ...(opts?.withoutIcon ? { icon: null } : {}),
    });
  };

  const close = () => toast.dismiss(notificationId);

  return { update, onSuccess, onError, close };
};

export const notify = (
  title = 'Error',
  message: React.ReactNode = 'Error',
  variant = 'red',
  autoClose: number | boolean = 5000,
) => {
  const id = uuidv4();

  const duration = typeof autoClose === 'number' ? autoClose : autoClose === false ? Infinity : 5000;

  if (['red', 'error', 'destructive'].includes(variant)) {
    toast.error(title, {
      id,
      duration,
      description: message,
      icon: null,
    });
  } else if (['green', 'success'].includes(variant)) {
    toast.success(title, {
      id,
      duration,
      description: message,
      icon: null,
    });
  } else if (['yellow', 'orange', 'warning'].includes(variant)) {
    toast.warning(title, {
      id,
      duration,
      description: message,
      icon: null,
    });
  } else {
    toast.info(title, {
      id,
      duration,
      description: message,
      icon: null,
    });
  }

  return () => toast.dismiss(id);
};
